/** Soft-separation pure math (crowd util). Role skips / catalog stay in content. */

export type SepNeighbor<T> = { e: T; d: number };

/** Drop sep component along intent when walking. */
export function lateralizeSepImpulse(
  sx: number,
  sy: number,
  intentVx: number,
  intentVy: number,
  walkEnter: number,
): { sx: number; sy: number } {
  const prefSpd = Math.hypot(intentVx, intentVy);
  if (prefSpd < walkEnter) return { sx, sy };
  const inv = 1 / prefSpd;
  const ix = intentVx * inv;
  const iy = intentVy * inv;
  const along = sx * ix + sy * iy;
  return { sx: sx - along * ix, sy: sy - along * iy };
}

export function clampSepImpulse(
  sx: number,
  sy: number,
  maxImpulse: number,
): { sx: number; sy: number } {
  const mag = Math.hypot(sx, sy);
  if (mag <= maxImpulse || mag < 1e-6) return { sx, sy };
  const s = maxImpulse / mag;
  return { sx: sx * s, sy: sy * s };
}

/** Keep at most k nearest neighbors without sorting the full list. */
export function considerTopK<T>(
  buf: SepNeighbor<T>[],
  item: SepNeighbor<T>,
  k: number,
): void {
  if (k <= 0) return;
  if (buf.length < k) {
    buf.push(item);
    return;
  }
  let worst = 0;
  for (let i = 1; i < buf.length; i++) {
    if (buf[i]!.d > buf[worst]!.d) worst = i;
  }
  if (item.d < buf[worst]!.d) buf[worst] = item;
}
